<template>
  <div class="flex flex-column gap-3">
    <div v-if="loading">
      <div class="flex align-items-center justify-content-center h-20rem">
        <a-spin />
      </div>
    </div>

    <template v-else>
      <div class="flex justify-content-between align-items-center" v-if="associate">
        <h3 class="m-0" v-if="attendanceRate && attendanceRate[associate.id]">
          Attendance Rate:
          {{ (attendanceRate[associate.id] * 100).toFixed(0) }}%
        </h3>
        <a-range-picker
          class="col-6 ml-auto"
          format="MM/DD/YYYY"
          v-model="attendanceRange"
          valueFormat="YYYY-MM-DD"
          :ranges="dateRange"
        />
      </div>
      <associate-kpi :kpi-stats="kpiStats"
    /></template>
  </div>
</template>

<script>
import AssociateKpi from '@/components/associate-kpi.vue'
import util from '@/util'
import { DatePicker, notification, Spin } from 'ant-design-vue'
import { createNamespacedHelpers } from 'vuex'
import moment from 'moment-timezone'

const { mapActions: profileActions, mapState: profileState } = createNamespacedHelpers('profile')

export default {
  components: {
    'a-spin': Spin,
    'a-range-picker': DatePicker.RangePicker,
    'associate-kpi': AssociateKpi
  },
  props: {
    associate_number: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      showRangeKpi: false,

      kpiTo: undefined,
      kpiFrom: undefined,

      loading: false,

      attendanceRange: [
        moment().startOf('month').utc().tz(this.$store.state.applicationState.timeZone),
        moment().utc().tz(this.$store.state.applicationState.timeZone)
      ]
    }
  },
  watch: {
    attendanceRange: {
      handler() {
        if (this.associate?.id) this.loadAttendanceRate()
        this.loadKpi()
      },
      deep: true
    },
    associate_number: {
      handler(newVal) {
        if (newVal) {
          this.loadKpi()
          if (this.associate?.id) this.loadAttendanceRate()
        }
      },
      immediate: true
    }
  },
  computed: {
    ...profileState({
      kpiStats: state => state.associateKPI,
      associate: state => state.associate,
      attendanceRate: state => state.associateAttendanceRate
    }),

    dateRange() {
      return {
        Today: [moment(), moment()],
        'This Month': [moment().startOf('month'), moment().endOf('month')]
      }
    }
  },
  methods: {
    ...profileActions(['getKPI', 'getAttendanceRate']),

    showNotification(type, message, description) {
      notification[type]({
        message,
        description
      })
    },

    async loadKpi() {
      this.loading = true

      const payload = {
        associate_number: this.associate_number,
        start: util.convertDateTimeToUTC(this.attendanceRange[0]),
        end: util.convertDateTimeToUTC(this.attendanceRange[1])
      }

      try {
        await this.getKPI(payload)
      } catch (error) {
        notification.error({
          message: 'KPI Load Error',
          description: error
        })
      } finally {
        this.loading = false
      }
    },

    async loadAttendanceRate() {
      if (!this.associate.id) {
        this.showNotification('error', 'Error', 'Associate is not defined')

        return
      }
      const payload = {
        id: this.associate.id,
        start_date: moment(this.attendanceRange[0]).utc().startOf('day').format('YYYY-MM-DD'),
        end_date: moment(this.attendanceRange[1]).utc().startOf('day').format('YYYY-MM-DD')
      }

      try {
        await this.getAttendanceRate(payload)
      } catch (error) {
        this.showNotification('error', 'Error', typeof error === 'string' ? error : error?.message)
      }
    }
  }
}
</script>
